import React, { useEffect, useRef, useState } from "react";
import { colors, css, glyphs} from "../../Styles";
import { ColumnFilter, ColumnFiltersState } from "@tanstack/react-table";
import NewButton from "../BaseComponents/newButton";
import { ButtonTypes } from "../../Definitions";

type filterDisplayListProps = {
  filters: ColumnFiltersState
  setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
  disabled?: boolean
} 

export default function FilterDisplayList({ filters, setColumnFilters, disabled=false}: filterDisplayListProps) {
  const resizeRef = useRef<HTMLDivElement>(null);
  const [overflowScroll, setOverflowScroll] = useState<boolean>(false)

  // Handle overflow
  // useEffect(() => {
  //   console.log("Height:", height);
  //   if (height > 0) {
  //     setOverflowScroll(height > 80);
  //   }
  // }, [height]);
  
  // Remove filter from list
  const onClearFilter = (filterId: string, valueToRemove: { id: number; label: string }) => {
    setColumnFilters((prev) => {
      return prev
        .map((filter) => {
          if (filter.id !== filterId) return filter;
  
          if (Array.isArray(filter.value)) {
            const newValues = filter.value.filter((v) => v.id !== valueToRemove.id);
            if (newValues.length === 0) {
              return null;
            }
            return { ...filter, value: newValues };
          }
  
          return null;
        })
        .filter((f): f is ColumnFilter => f !== null);
    });
  };

  return ( <> { filters.length > 0 ?
    <div ref = { resizeRef } style = {{
      display: "flex",
      flexWrap: "wrap",
      margin: "5px",
      gap: "5px",
      scrollbarColor: colors.greyPrimary + colors.transparent,
      scrollbarWidth: "thin",
      overflowY: overflowScroll ? "scroll" : "hidden",
      maxHeight: overflowScroll ? "80px" : "auto",
      backgroundColor: colors.greySecondary,
      borderRadius: "10px", 
      alignItems: "center",
      padding: "3.5px 10px",
      opacity: disabled ? "0.5" : "1"
    }}>
    
      {filters.map((filter, index) => {
        const values = Array.isArray(filter.value) ? filter.value : [filter.value];

        return values.map((value, i) => (
          <NewButton
            key={`${filter.id}-${i}`}
            content={value.label}
            buttonType={ButtonTypes.tagButton}
            endEnhancer={glyphs.Close({ size: "10px" })}
            onClick={() => onClearFilter(filter.id, value)}
            disabled={disabled}
            overrides={{
              baseStyles: { backgroundColor: colors.greyDarkPrimary },
              hoverStyles: { backgroundColor: colors.blackPrimary },
              disabledStyles: {opacity: "0.5"}
            }}
          />
        ));
      })}
    </div >
  : <></>} </> );
}